export default "__VITE_ASSET__DgpQ41hd__"